<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card class="box">
      <v-data-table :headers="headers" :items="payment_gateway_details_list" class="elevation-1 mytable" dense
        :search="search" :items-per-page="-1">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Payment Gateway Details List</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>


          </v-toolbar>

          <span style="width: 20px;"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line
                hide-details></v-text-field>
            </v-col>
            <span style="width: 20px;"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <!-- :disabled="isallowed == false ? true : false" -->
                <v-btn class="mb-2 button" v-on="on" :disabled="isallowed == false ? true : false" small>Add Payment
                  Gateway Details</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>

                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete dense v-model="editedItem.paymentgateway_id" :items="payment_gateway_list"
                            item-text="name" item-value="id" label="Payment Gateway" persistent-hint
                            hint="Payment Gateway..." single-line></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Name" v-model="editedItem.name" placeholder="Please Enter Name">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Merchant Id" v-model="editedItem.merchantid"
                            placeholder="Please Enter Merchant Id">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <!-- <v-row>
                        <v-col cols="12">
                          <v-text-field label="Merchant Key" v-model="editedItem.merchantkey"
                            placeholder="Please Enter Merchant Key">
                          </v-text-field>

                        </v-col>
                      </v-row> -->
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Main Home Url" v-model="editedItem.main_home_url"
                            placeholder="Please Enter Main Home Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Merchant Iv" v-model="editedItem.merchantiv"
                            placeholder="Please Enter Merchant Iv">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Account No" v-model="editedItem.account_no"
                            placeholder="Please Enter Account No">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Bank Name" v-model="editedItem.bank_name"
                            placeholder="Please Enter Bank Name">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Bank Address" v-model="editedItem.bank_address"
                            placeholder="Please Enter Bank Address">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Whitelisted Ip" v-model="editedItem.whitelisted_ip"
                            placeholder="Please Enter Whitelisted Ip">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Qrcode path" v-model="editedItem.qrcode_path"
                            placeholder="Please Enter Qrcode path">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Bank Branch" v-model="editedItem.bank_branch"
                            placeholder="Please Enter Bank Branch">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Account Type" v-model="editedItem.account_type"
                            placeholder="Please Enter Account Type">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Beneficiary Name" v-model="editedItem.beneficiary_name"
                            placeholder="Please Enter Beneficiary Name">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Ifsc Code" v-model="editedItem.ifsc_code"
                            placeholder="Please Enter Ifsc Code">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="In Favour Of" v-model="editedItem.in_favour_of"
                            placeholder="Please Enter In Favour Of">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Redirect Url" v-model="editedItem.redirecturl"
                            placeholder="Please Enter Redirect Url">
                          </v-text-field>

                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Mobile Redirect Url" v-model="editedItem.mobileredirecturl"
                            placeholder="Please Enter Mobile Redirect Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Out Standing Redirect Url" v-model="editedItem.outstandingredirecturl"
                            placeholder="Please Enter Out Standing Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Amission Redirect Url" v-model="editedItem.admissionredirecturl"
                            placeholder="Please Enter Amission Redirect Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Pg Url" v-model="editedItem.pgurl" placeholder="Please Enter Pg Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Pg Status Api" v-model="editedItem.pgstatusapi"
                            placeholder="Please Enter Pg Status Api">
                          </v-text-field>

                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Website Name" v-model="editedItem.website_name"
                            placeholder="Please Enter Website Name">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Home Url" v-model="editedItem.home_url"
                            placeholder="Please Enter Home Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Admission Fee Home Url" v-model="editedItem.admission_fee_home_url"
                            placeholder="Please Enter Admission Fee Home Url">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Debit Card Charges" v-model="editedItem.debit_card_charges"
                            placeholder="Please Enter Debit Card Charges">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Credit Card Charges" v-model="editedItem.credit_card_charges"
                            placeholder="Please Enter Credit Card Charges">
                          </v-text-field>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Net Banking Card Charges" v-model="editedItem.netbanking_card_charges"
                            placeholder="Please Enter Net Banking Card Charges">
                          </v-text-field>

                        </v-col>
                      </v-row>


                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="other_information_dialog" max-width="1500px" persistent>
              <v-card>
                <br>

                <v-card-text>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Main Home Url : {{
                      show_other_information.main_home_url
                      }}</v-col>
                    <!-- <v-col style="font-weight: bold;" sm="12" md="4">Merchant Key : {{
                      show_other_information.merchantkey
                    }}</v-col> -->
                    <v-col style="font-weight: bold;" sm="12" md="4">Merchant Iv : {{
                      show_other_information.merchantiv
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Account No : {{ show_other_information.account_no
                      }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Bank Name : {{
                      show_other_information.bank_name
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Bank Address : {{
                      show_other_information.bank_address
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Whitelisted Ip : {{
                      show_other_information.whitelisted_ip
                      }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Qrcode path : {{ show_other_information.qrcode_path
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Bank Branch : {{ show_other_information.bank_branch
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Account Type : {{
                      show_other_information.account_type
                      }}</v-col>

                  </v-row>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Beneficiary Name : {{
                      show_other_information.beneficiary_name
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Ifsc Code : {{ show_other_information.ifsc_code
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">In Favour Of : {{
                      show_other_information.in_favour_of
                      }}</v-col>

                  </v-row>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Redirect Url : {{
                      show_other_information.redirecturl
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Mobile Redirect Url : {{
                      show_other_information.mobileredirecturl
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Amission Redirect Url : {{
                      show_other_information.admissionredirecturl
                      }}</v-col>

                  </v-row>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Pg Url : {{ show_other_information.pgurl
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Pg Status Api : {{
                      show_other_information.pgstatusapi
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Website Name : {{
                      show_other_information.website_name
                      }}</v-col>

                  </v-row>
                  <v-row>
                    <v-col style="font-weight: bold;" sm="12" md="4">Home Url : {{ show_other_information.home_url
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Admission Fee Home Url : {{
                      show_other_information.admission_fee_home_url
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Debit Card Charges : {{
                      show_other_information.debit_card_charges
                      }}</v-col>

                  </v-row>

                  <v-row justify="center">


                    <v-col style="font-weight: bold;" sm="12" md="4">Credit Card Charges : {{
                      show_other_information.credit_card_charges
                      }}</v-col>
                    <v-col style="font-weight: bold;" sm="12" md="4">Net Banking Card Charges : {{
                      show_other_information.netbanking_card_charges
                      }}</v-col>


                    <v-col style="font-weight: bold;" sm="12" md="4"></v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-center"><v-btn color="warning"
                    @click="other_information_dialog = false">Close</v-btn></v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <template v-slot:[`item.other_information`]="{ item }">
          <v-btn color="success" icon dark @click="getother_information(item)" title="Other Information">
            <v-icon> mdi-book-open</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-avatar style size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit" style>edit</v-icon>
          </v-avatar>

        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class=" v-icon-size" color="red" @click="delete_payment_gateway_details(item)"
                :loading="delete_load">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
        </template>

      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    other_information_dialog: false,
    show_other_information: "",
    other_information: "",
    color: "",
    isallowed: false,
    snackbar: false,
    overlay: false,
    items: [],
    dialog: false,
    delete_load: false,
    search: "",

    headers: [
      {
        text: "Payment Gateway",
        value: "paymentgateway",
      },
      {
        text: "Name",
        value: "name",
      },

      {
        text: "Merchant Id",
        value: "merchantid",
      },
      {
        text: "Other Information",
        value: "other_information",
      },
      { text: "Actions", value: "action", },
      { text: "Delete", value: "delete", },

      // {
      //   text: "Merchant Key",
      //   value: "merchantkey",
      // },

      // {
      //   text: "Merchant Iv",
      //   value: "merchantiv",
      // },

      // {
      //   text: "Account No",
      //   value: "account_no",
      // },

      // {
      //   text: "Bank Name",
      //   value: "bank_name",
      // },

      // {
      //   text: "Bank Address",
      //   value: "bank_address",
      // },

      // {
      //   text: "Whitelisted Ip",
      //   value: "whitelisted_ip",
      // },

      // {
      //   text: "Qrcode path",
      //   value: "qrcode_path",
      // },

      // {
      //   text: "Bank Branch",
      //   value: "bank_branch",
      // },

      // {
      //   text: "Account Type",
      //   value: "account_type",
      // },

      // {
      //   text: "Beneficiary Name",
      //   value: "beneficiary_name",
      // },

      // {
      //   text: "Ifsc Code",
      //   value: "ifsc_code",
      // },

      // {
      //   text: "In Favour Of",
      //   value: "in_favour_of",
      // },

      // {
      //   text: "Redirect Url",
      //   value: "redirecturl",
      // },

      // {
      //   text: "Mobile Redirect Url",
      //   value: "mobileredirecturl",
      // },


      // {
      //   text: "Out Standing Redirect Url",
      //   value: "outstandingredirecturl",
      // },
      // {
      //   text: "Amission Redirect Url",
      //   value: "admissionredirecturl",
      // },
      // {
      //   text: "Pg Url",
      //   value: "pgurl",
      // },
      // {
      //   text: "Pg Status Api",
      //   value: "pgstatusapi",
      // },
      // {
      //   text: "Website Name",
      //   value: "website_name",
      // },
      // {
      //   text: "Home Url",
      //   value: "home_url",
      // },
      // {
      //   text: "Admission Fee Home Url",
      //   value: "admission_fee_home_url",
      // },
      // {
      //   text: "Debit Card Charges",
      //   value: "debit_card_charges",
      // },
      // {
      //   text: "Credit Card Charges",
      //   value: "credit_card_charges",
      // },
      // {
      //   text: "Net Banking Card Charges",
      //   value: "netbanking_card_charges",
      // },


    ],
    payment_gateway_details_list: [],
    payment_gateway_list: [],

    editedIndex: -1,
    editedItem: {
      id: "",
      paymentgateway_id: "",
      name: "",
      merchantid: "",
      main_home_url: "",
      // merchantkey: "",
      merchantiv: "",
      account_no: "",
      bank_name: "",
      bank_address: "",
      whitelisted_ip: "",
      qrcode_path: "",
      bank_branch: "",
      account_type: "",
      beneficiary_name: "",
      in_favour_of: "",
      redirecturl: "",
      mobileredirecturl: "",
      outstandingredirecturl: "",
      admissionredirecturl: "",
      pgurl: "",
      website_name: "",
      home_url: "",
      admission_fee_home_url: "",
      debit_card_charges: "",
      credit_card_charges: "",
      netbanking_card_charges: "",

    },
    defaultItem: {
      id: "",
      paymentgateway_id: "",
      name: "",
      merchantid: "",
      main_home_url: "",
      // merchantkey: "",
      merchantiv: "",
      account_no: "",
      bank_name: "",
      bank_address: "",
      whitelisted_ip: "",
      qrcode_path: "",
      bank_branch: "",
      account_type: "",
      beneficiary_name: "",
      in_favour_of: "",
      redirecturl: "",
      mobileredirecturl: "",
      outstandingredirecturl: "",
      admissionredirecturl: "",
      pgurl: "",
      website_name: "",
      home_url: "",
      admission_fee_home_url: "",
      debit_card_charges: "",
      credit_card_charges: "",
      netbanking_card_charges: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Payment Gateway Details" : "Edit Payment Gateway Details";
    },

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },


  mounted() {
    this.onload();
  },
  methods: {
    getother_information(item) {
      this.show_other_information = item;
      this.other_information_dialog = true;
    },
    delete_payment_gateway_details(item) {

      if (!confirm("Are You Sure You Want To Delete This Payment Geteway Details ...?")) return;
      const formData = {
        id: item.id,

      };
      this.delete_load = true;
      axios
        .post("/AccountingAndFees/deletePaymentGetewayDetails", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", res.data.snackbar); // show snackbar on success
            //  this.payment_gateway_details_list = res.data.payment_gateway_details_list;
            this.delete_load = false;
            this.onload();
            this.isallowed = res.data.isallowed;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_load = false;

        });
    },
    onload() {
      this.overlay = true;
      axios
        .post("/AccountingAndFees/paymentGetewayDetails")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.payment_gateway_list = res.data.payment_gateway_list;
            this.payment_gateway_details_list = res.data.payment_gateway_details_list;
            this.isallowed = res.data.isallowed;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.isallowed = res.data.isallowed
            this.overlay = false;
          }
          else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          sessionStorage.setItem("error-trace", res.data.error_trace);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AccountingAndFees/saveEditPaymentGetewayDetails", this.editedItem)
            .then((res) => {
              if (res.data.flag == "YES") {
                this.onload();
                this.dialog = false;
                this.showSnackbar("#4caf50", res.data.snackbar); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        if (this.isValidated()) {
          axios
            .post("/AccountingAndFees/savePaymentGetewayDetails", this.editedItem)
            .then((res) => {
              if (res.data.flag == "YES") {
                // this.standred_master_list.push(this.editedItem);
                this.showSnackbar("#4caf50", res.data.snackbar); // show snackbar on success
                this.onload();
                this.dialog = false;
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Something went wrong..!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      }
    }, // end of save()
    initializeErrorMsgFalse() {
      this.errorMsg.name = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {

      this.editedIndex = this.payment_gateway_details_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },



    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },









    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()

  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>
